/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type UserConversationsCountFilterConfigColumn =
  (typeof UserConversationsCountFilterConfigColumn)[keyof typeof UserConversationsCountFilterConfigColumn];

export const UserConversationsCountFilterConfigColumn = {
  user_conversations_count: 'user_conversations_count',
} as const;
